<template>
  <div class="new-search-country-con">
    <!-- 新闻选择框 -->
    <div
      class="country-dropdown"
      @click.stop="isCountryShow = !isCountryShow"
      v-if="$route.meta.title == 'NewsIndex' || $route.meta.title == 'NewsList'"
    >
      <span class="select-country-con">
        <template
          v-if="
            selectCountryObj.countryCode == null ||
            selectCountryObj.countryCode == '' ||
            selectCountryObj.countryCode == 'undefined'
          "
        >
          <span class="country-placeholder">Select Country</span>
        </template>
        <template v-else>
          <img :src="selectCountryObj.urlBanner" class="select-country-img" />
          <span class="select-country-name">{{ selectCountryObj.nameEn }}</span>
        </template>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isCountryShow }"
        ></i>
      </span>
    </div>
    <!-- 制裁选择框 -->

    <div
      class="sanction-dropdown"
      @click.stop="isSanctionShow = !isSanctionShow"
      v-else
    >
      <span class="select-country-con">
        <span class="select-country-name">{{
          selectSanctionObj.sanctionName
        }}</span>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isSanctionShow }"
        ></i>
      </span>
    </div>
    <i
      class="iconfont icon-search tip-btn"
      v-if="$route.meta.type != 'index'"
    ></i>

         <el-autocomplete  v-if="selectSanctionObj.sanctionCode =='4'&&$route.name!='newsIndex'" id="c308fb" clearable v-model="searchKeyword" style="width: 100%;height: auto;"
              :highlight-first-item="true" :debounce="300" :trigger-on-focus="false" :autofocus="true" class="search-country-input"
              @select="handleSelect" :fetch-suggestions="querySearchAsync"     :placeholder="placeholder" size="large">
           
            </el-autocomplete>
    <el-input
   v-else
      v-model="searchKeyword"
      class="search-country-input"
      :placeholder="placeholder"
      @keyup.enter.native="onSearchBtn()"
    ></el-input>

       {{  }}
    <el-button
      type="primary"
      round
      v-if="$route.meta.type == 'index'"
      class="search-country-btn"
       :class="this.$route.name=='newsIndex'?'NewsBack':'RiskBack'"
      @click="onSearchBtn"
      ><i class="iconfont icon-search"></i>Search</el-button
    >
    <i class="iconfont icon-search search-btn" @click="onSearchBtn" v-else></i>
    <!-- 选择国家 -->
    <div
      ref="countryRef"
      class="country-popper"
      :class="{ 'country-show-popper': isCountryShow }"
    >
      <div class="country-popper-arrow"></div>
      <div class="country-popper-con">
        <div class="state-con">
          <div
            class="country-state-item"
            :class="{ activeState: selectStateIndex == index }"
            v-for="(item, index) in stateList"
            :key="index"
            @click="onChangeState(index)"
          >
            <span class="country-name">{{ item.continent.enName }}</span>
            <span class="country-countryCount">{{
              item.continent.countryNumStr
            }}</span>
          </div>
        </div>
        <div class="state-country-con">
          <div
            class="state-country-item"
            v-for="(item, index) in stateCountryList"
            :key="index"
            :class="{
              activeCountry: selectCountryObj.countryCode == item.countryCode,
            }"
            @click="selectCountryObjFn(item)"
          >
            <div class="state-country-item-con">
              <img :src="item.urlBanner" />
              <div class="state-country-info">
                <div class="state-country-name">{{ item.nameEn }}</div>
                <div class="state-country-companyCount">
                  {{ item.companyNumStr }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择制裁下拉框 -->
    <div
      ref="sanctionRef"
      class="sanction-popper"
      :class="{ 'sanction-show-popper': isSanctionShow }"
    >
      <div
        class="sanction-item-con"
        v-for="(item, index) in sanctionList"
        :key="index"
        :class="{
          activeSanction: selectSanctionObj.sanctionCode == item.dictDataCode,
        }"
        @click="onSelectSanction(item)"
      >
        {{ item.dictDataName }}
      </div>
    </div>
    <!-- 登录弹窗 -->
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
  </div>
</template>

<script>
import Login from "@/components/login.vue";
import { getCountryCollection } from "@/api/companyApi.js";
export default {
  props: {
    // 是否头部
    isHeader: {
      type: Boolean,
      default: false,
    },
    // 默认信息
    countryCode: {
      type: String,
      default: "",
    },
    // 关键字
    keyword: {
      type: String,
      default: "",
    },
  },
  components: { Login },
  data() {
    return {
      loginDialog: false,
      placeholder: "Enter Keyword",
      searchKeyword: "", //搜索关键字
      isCountryShow: false, //选择国家提示框
      isSanctionShow: false, //选择制裁提示框
      selectCountryObj: {
        countryCode: "",
      },
      selectStateIndex: 0,
      countryCodeRisk:'',
      stateList: [], // 州列表
      stateCountryList: [], //选择州下的国家
      stateCountryListCopy: [], //选择州下的国家
      selectSanctionObj: {
        sanctionCode: "4",
        sanctionName: "Country",
      },
      sanctionList: [
          {
          dictDataCode: "4",
          dictDataName: "Country",
        },
        {
          dictDataCode: "1",
          dictDataName: "Company",
        },
        {
          dictDataCode: "2",
          dictDataName: "Person",
        },
        {
          dictDataCode: "3",
          dictDataName: "Product",
        },
      
      ],
    };
  },

  methods: {
    // 国家制裁添加国家下拉取
      querySearchAsync(queryString, cb) {
              const token = localStorage.getItem("token");
        if(token){
  if (queryString !== '') {
     
          let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList;
          Allcountry.forEach(item => {
            item.value = item.nameEn
            item.val = item.nameEn
          })
          let SelecrCountry = queryString ? Allcountry.filter(this.createStateFilter(queryString)) : Allcountry;
          cb(SelecrCountry);


      }
        }
        else{
       
          this.loginDialog=true
             cb([])
        }
        
    
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 国家制裁
     handleSelect(item) {
      console.log(`item`, item);
      console.log(this.$route.meta.title );
      
        //  this.$store.commit("setRefreshKey", new Date().getTime());
  this.countryCodeRisk=item.countryCode
          this.$router.push({
                  path: "/sanction/countryList",
                  query: {
                    keyword: item.nameEn,
                    CountryCode:   this.countryCodeRisk,
                    selectCode: 4,
                  },
                });
          
                if(this.$route.meta.title != "SanctionIndex"){
   this.onSearchBtn()

                }
                
    },
    // 搜索
    onSearchBtn() {
   
      const token = localStorage.getItem("token");
      if (token) {
        if (this.searchKeyword == "" || this.searchKeyword == null) {
          this.$message({
            message: this.placeholder,
            center: true,
            type: "error",
          });
        } else {
    
            
          if (this.$route.meta.type == "index") {
            // 首页 进行跳转页面
            if (this.$route.meta.title == "NewsIndex") {
              this.$router.push({
                path: "/news/list",
                query: {
                  keyword: this.searchKeyword,
                  selectCode: this.selectCountryObj.countryCode,
                },
              });
            } else {
              if (this.selectSanctionObj.sanctionCode == "1") {
                // 公司
                this.$router.push({
                  path: "/sanction/companyList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 1,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "2") {
                // 个人
                this.$router.push({
                  path: "/sanction/personList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 2,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "3") {
                // 产品
                this.$router.push({
                  path: "/sanction/productList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 3,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "4") {
                // 国家
                this.$router.push({
                  path: "/sanction/countryList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 4,
                    CountryCode:this.countryCodeRisk,
                  },
                });
              }
            }
          } else {
            // 在列表页 进行检索
            let params;
            if (this.$route.meta.title == "NewsList") {
              params = {
                searchKeyword: this.searchKeyword,
                selectCode: this.selectCountryObj.countryCode,
              };
            } else {

              params = {
                searchKeyword: this.searchKeyword,
                selectCode: this.selectSanctionObj.sanctionCode,
                CountryCode:this.countryCodeRisk,
              };
              console.log(params);
              
            }
            this.$emit("searchFn", params);
          }
        }
      } else {
        this.loginDialog = true;
      }
    },
    //   获取国家列表
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList")
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
        }
      }
    },
    //   设置国家图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../static" + getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },
    // 切换州
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },
    // 选择国家
    selectCountryObjFn(item) {
      this.selectCountryObj = item;
      this.isCountryShow = false;
      this.$emit("selectCountry", item.countryCode);
    },
    // 选择制裁类型
    onSelectSanction(item) {
      console.log(`item`, item);
      if (item.dictDataCode == "1") {
        this.placeholder = "Enter Company Name";
      } else if (item.dictDataCode == "2") {
        this.placeholder = "Enter Person Name";
      } else if (item.dictDataCode == "3") {
        this.placeholder = "Enter Product Name";
      } else if (item.dictDataCode == "4") {
        this.placeholder = "Enter Country Name";
      }
      this.searchKeyword = "";
      this.selectSanctionObj.sanctionCode = item.dictDataCode;
      this.selectSanctionObj.sanctionName = item.dictDataName;
      this.isSanctionShow = false;
    },
    handleClickOutside(event) {
      if (
        this.$route.meta.title == "NewsIndex" ||
        this.$route.meta.title == "NewsList"
      ) {
        let countryRef = this.$refs.countryRef;
        // 判断点击的区域是否在元素外部
        if (countryRef && !countryRef.contains(event.target)) {
          this.isCountryShow = false;
        }
      } else {
        let sanctionRef = this.$refs.sanctionRef;
        // 判断点击的区域是否在元素外部
        if (sanctionRef && !sanctionRef.contains(event.target)) {
          this.isSanctionShow = false;
        }
      }
    },
  },
  mounted() {
    if (
      this.$route.meta.title == "NewsIndex" ||
      this.$route.meta.title == "NewsList"
    ) {
      this.placeholder = "Enter Keyword";
    } else if (this.$route.path == "/sanction/productList") {
      this.placeholder = "Enter Product Name";
      this.selectSanctionObj.sanctionCode = 3;
    } else if (this.$route.path == "/sanction/personList") {
      this.placeholder = "Enter Person Name";
      this.selectSanctionObj.sanctionCode = 2;
    } else if (
      this.$route.path == "/sanction/companyList" ||
      this.$route.path == "/sanction/home"
    ) {
      this.placeholder = "Enter Company Name";
      this.selectSanctionObj.sanctionCode = 1;
    } else if (this.$route.path == "/sanction/countryList"||this.$route.query.selectCode==4) {
      this.placeholder = "Enter Country Name";
      this.selectSanctionObj.sanctionCode = 4;
    }

    this.getCountryList();
    this.searchKeyword = this.keyword;
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.new-search-country-con {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 1000px;
  height: 70px;
  margin-bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(42, 104, 142, 0.18);
  border-radius: 35px;
}

.country-dropdown {
  position: relative;
  width: 160px;
  border-radius: 35px 0 0 35px;
}

.sanction-dropdown {
  position: relative;
  width: 152px;
  border-radius: 35px 0 0 35px;
}
.country-dropdown::after,
.sanction-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}
.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 20px;
  cursor: pointer;
}
.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
  /* color: #8497ab; */
}
.select-country-con i {
  font-size: 12px;
  color: #1a2332;
  transition: all 0.3s;
}
.country-arrow {
  transform: rotate(180deg);
}
.select-country-img {
  width: 36px;
  height: 22px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}
.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 16px;
  color: #1a2332;
  overflow: hidden;
}
.sanction-dropdown .select-country-name {
  font-size: 1.28571428571428rem
}
.country-popper {
  position: absolute;
  top: 84px;
  left: 50%;
  transform: translateX(-50%);
  width: 1000px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}
.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}
.sanction-popper {
  position: absolute;
  top: 74px;
  left: 0;
  width: 200px;
  height: auto;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}
.sanction-show-popper {
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transform: rotateX(0deg);
}
.sanction-item-con {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}
.sanction-item-con:not(:last-child) {
  margin-bottom: 4px;
}
.sanction-item-con:hover,
.sanction-item-con.activeSanction {
  color: #f9722c;
  background: #f5f5f5;
}
.sanction-theme .sanction-item-con:hover,
.sanction-theme .sanction-item-con.activeSanction {
  color: #f9722c;
  background: #f5f5f5;
}
.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.country-popper-arrow {
  left: 221px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}
.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}
.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}
.country-popper-con .state-con {
  width: 220px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}
.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}
.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}
.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}
.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}
.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}
.news-theme .country-popper-con .country-state-item:hover .country-name,
.news-theme .country-popper-con .country-state-item.activeState .country-name {
  color: #3ebb72;
}

.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}
.country-popper-con .state-country-con {
  width: 953px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}
.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}
.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}
.news-theme .country-popper-con .state-country-item:hover,
.news-theme .country-popper-con .state-country-item.activeCountry {
  border-color: #3ebb72;
}

.country-popper-con .state-country-item:hover .state-country-item-con,
.country-popper-con .state-country-item.activeCountry .state-country-item-con {
  transform: scale(1.05);
}
.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}
.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}
.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}
.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}
.search-country-input {
  flex: 1;
  padding: 0 20px;
}
.search-country-input >>> .el-input__inner {
  line-height: 70px;
  font-size: 18px;
  padding: 0 !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}
.search-country-input >>> .el-input__inner::placeholder {
  font-weight: 400;
  color: #8497ab;
  
}
.search-country-btn {
  display: flex;
  align-items: center;
  width: 152px;
  height: 70px;
  margin: 0 0 0 15px;
  font-size: 18px;
  color: #ffffff;
  background: #1290c9;
  border-radius: 0px 35px 35px 0px;
}
.search-country-btn >>> span {
  display: flex;
  align-items: center;
}
.search-country-btn i {
  font-size: 40px;
}

.page-top-con .new-search-country-con {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 46.875%;
  height: 54px;
  margin-bottom: 0;
  box-shadow: none;
  border-radius: 4px;
  z-index: 999;
}
.page-top-con .country-dropdown {
  width: 174px;
}

.page-top-con .country-dropdown .select-country-con {
  padding-left: 10px;
}
.page-top-con .select-country-img {
  width: 34px;
  height: 20px;
}
.page-top-con .select-country-name {
  line-height: 18px;
  font-size: 14px;
}
.page-top-con .select-country-con i {
  font-size: 14px;
}
.page-top-con .search-country-input {
  padding: 0 60px 0 40px;
}
.page-top-con .search-country-input >>> .el-input__inner {
  line-height: 54px;
  font-size: 16px;
}
.page-top-con .new-search-country-con .icon-search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 26px;
}
.page-top-con .new-search-country-con .tip-btn {
  position: absolute;
  left: 185px;
  top: 50%;
  transform: translateY(-50%);
  color: #999999;
}
.page-top-con .new-search-country-con .search-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #1a2332;
  cursor: pointer;
}
.page-top-con .country-popper {
  top: 68px;
}
.page-top-con .country-popper-arrow {
  left: 284px;
}
.page-top-con .sanction-dropdown {
  width: 144px;
}
.page-top-con .sanction-dropdown .select-country-name {
  line-height: 1;
  font-size: 16px;
}
.page-top-con .new-search-country-con .sanction-dropdown + .tip-btn {
  left: 155px;
}
.page-top-con .sanction-popper {
  top: 58px;
}
@media (max-width: 1440px) {
  .new-search-country-con {
    width: 666px;
    height: 46px;
    margin-bottom: 20px;
    border-radius: 24px;
  }
  .country-dropdown {
    width: 110px;
    border-radius: 24px 0 0 24px;
  }

  .sanction-dropdown {
    width: 100px;
    border-radius: 24px 0 0 24px;
  }
  .country-dropdown::after,
  .sanction-dropdown::after {
    height: 20px;
  }
  .select-country-con {
    height: 26px;
    padding: 0 4px 0 10px;
  }
  .select-country-con .country-placeholder {
    font-size: 12px;
  }
  .select-country-con i {
    transform: scale(0.8);
  }
  .select-country-img {
    width: 24px;
    height: 15px;
    margin-right: 4px;
  }
  .select-country-name {
    margin-right: 2px;
    line-height: 14px;
    font-size: 12px;
  }
  .sanction-dropdown .select-country-name {
    font-size: 14px;
  }
  .country-popper {
    top: 56px;
    width: 666px;
    height: 200px;
    padding: 12px 3px 0px 0;
    border-radius: 8px;
  }
  .country-show-popper {
    width: 785px;
    height: 252px;
  }
  .sanction-popper {
    top: 50px;
    width: 140px;
    padding: 8px 0;
    border-radius: 4px;
  }

  .country-popper-arrow {
    left: 152px;
    top: -8px;
    border-width: 8px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }
  .country-popper-arrow::after {
    border-width: 8px;
  }
  .country-popper-con .state-con {
    width: 148px;
    height: calc(100% - 12px);
  }
  .country-popper-con .country-state-item {
    height: 32px;
    padding: 0 14px;
  }
  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 6px;
  }
  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }
  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }
  .country-popper-con .state-country-con {
    width: 637px;
    padding-left: 14px;
  }
  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }
  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }
  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }
  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }
  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }
  .sanction-item-con {
    height: 26px;
    line-height: 26px;
    padding: 0 14px;
    font-size: 14px;
  }
  .sanction-item-con:not(:last-child) {
    margin-bottom: 2px;
  }

  .search-country-input {
    padding: 0 14px;
  }
  .search-country-input >>> .el-input__inner {
    line-height: 46px;
    font-size: 14px !important;
  }
  .search-country-btn {
    width: 102px;
    height: 46px;
    padding: 0 0 0 10px;
    font-size: 14px;
    border-radius: 0px 24px 24px 0px;
  }
  .search-country-btn i {
    font-size: 26px;
  }

  .page-top-con .new-search-country-con {
    height: 36px;
    border-radius: 3px;
  }
  .page-top-con .country-dropdown {
    width: 116px;
  }
  .page-top-con .country-dropdown .select-country-con {
    padding-left: 6px;
  }
  .page-top-con .select-country-img {
    width: 22px;
    height: 14px;
  }
  .page-top-con .select-country-name {
    line-height: 14px;
    font-size: 12px;
  }
  .page-top-con .select-country-con i {
    font-size: 12px;
  }
  .page-top-con .search-country-input {
    padding: 0 40px 0 26px;
  }
  .page-top-con .search-country-input >>> .el-input__inner {
    line-height: 36px;
    font-size: 14px;
  }
  .page-top-con .new-search-country-con .icon-search {
    width: 14px;
    height: 14px;
    font-size: 18px;
  }
  .page-top-con .new-search-country-con .tip-btn {
    left: 124px;
  }
  .page-top-con .new-search-country-con .search-btn {
    right: 14px;
  }
  .page-top-con .country-popper {
    top: 45px;
  }
  .page-top-con .country-popper-arrow {
    left: 159px;
  }
  .page-top-con .sanction-dropdown {
    width: 96px;
  }
  .page-top-con .sanction-dropdown .select-country-name {
    font-size: 14px;
  }
  .page-top-con .new-search-country-con .sanction-dropdown + .tip-btn {
    left: 103px;
  }
  .page-top-con .sanction-popper {
    top: 38px;
  }
}
.NewsBack{
  background-color: #3EBB72 !important;

}
.RiskBack{
    background-color: #F9722C !important;
}
</style>
